<div class="row"></div>
<div class="container">
  <div class="row">
    <div class="col-2"></div>
    <div class="col-8">
      <h1>Mentions légales</h1>

      Le présent site est la propriété de :<br /><br />

      Sinepsy -<br /><br />

      Conception & Réalisation technique : Agence "Felixis"<br /><br /><br />

      <label>Informatique et libertés</label>

      <p>
        Les liens hypertexte présents sur le site de Sinepsy et aiguillant les
        utilisateurs vers d'autres sites Internet n'engagent pas la
        responsabilité de la rédaction du site quant au contenu de ces sites.<br /><br />

        Lorsque des données présentes sur ce site ont un caractère nominatif,
        les utilisateurs doivent en faire un usage conforme aux réglementations
        en vigueur et aux recommandations de la Commission nationale de
        l'informatique et des libertés (CNIL).<br /><br />

        Les informations utilisées ne doivent l'être qu'à des fins personnelles,
        associatives ou professionnelles, toute diffusion ou utilisation à des
        fins commerciales ou publicitaires étant exclues.<br /><br />

        Conformément à la loi « informatique et libertés » du 6 janvier 1978,
        vous pouvez vous opposer au traitement informatique des données vous
        concernant recueillies par l’organisateur et vous bénéficiez d’un droit
        d’accès, de rectification et de radiation de ces données.<br /><br />

        Droits d'auteur et/ou Droits sur les dessins, photos et textes<br /><br />

        Le présent site constitue une œuvre dont Sinepsy est l'auteur au sens
        des articles L.111.1 et suivants du Code de la propriété intellectuelle.
        <br /><br />Les photographies, textes, slogans, dessins, images,
        documents PDF ainsi que toutes œuvres intégrées dans le site sont la
        propriété de Sinepsy ou de tiers ayant autorisé Sinepsy à les utiliser.
        <br /><br />Les logos, icônes et puces graphiques représentés sur le
        site sont protégés au titre des droits d'auteur et des articles L.511.1
        et suivants du Code de la propriété intellectuelle relatifs à la
        protection des modèles déposés. <br /><br />Les reproductions, sur un
        support papier ou informatique, dudit site et des œuvres qui y sont
        reproduits sont autorisées sous réserve qu'elles soient strictement
        réservées à un usage personnel excluant tout usage à des fins
        publicitaires et/ou commerciales et/ou d'information et/ou qu'elles
        soient conformes aux dispositions de l'article L122-5 du Code de la
        Propriété Intellectuelle. <br /><br />A l'exception des dispositions
        ci-dessus, toute reproduction, représentation, utilisation ou
        modification, par quelque procédé que ce soit et sur quelque support que
        ce soit, de tout ou partie du site, de tout ou partie des différentes
        œuvres qui le composent, sans avoir obtenu l'autorisation préalable de
        Sinepsy, est strictement interdite et constitue un délit de
        contrefaçon.<br />
      </p>

      <label>Liens Hypertextes</label>
      <p>
        Sinepsy autorise tout site Internet ou tout autre support à le citer ou
        à mettre en place un lien hypertexte pointant vers son contenu.
        L’autorisation de mise en place d’un lien est valable pour tout support,
        à l’exception de ceux diffusant des informations à caractère polémique,
        pornographique, xénophobe ou pouvant, dans une plus large mesure porter
        atteinte à la sensibilité du plus grand nombre. Sinepsy décline toute
        responsabilité quant aux sites Internet qui possèdent un lien vers son
        site.<br />
      </p>

      <label>POLITIQUE DE CONFIDENTIALITÉ / RGPD :</label>

      <label>I. PRÉAMBULE :</label>
      <p>
        La présente politique de confidentialité définit et vous informe de la
        manière dont Sinepsy utilise et protège les informations que vous nous
        transmettez, le cas échéant, lorsque vous utilisez le présent site
        accessible à partir de l’URL suivante : www.Sinepsy.fr (ci-après le «
        Site »), Veuillez noter que cette politique de confidentialité est
        susceptible d’être modifiée ou complétée à tout moment par Sinepsy,
        notamment en vue de se conformer à toute évolution législative,
        règlementaire, jurisprudentielle ou technologique. Dans un tel cas, la
        date de sa mise à jour sera clairement identifiée en tête de la présente
        politique. Ces modifications engagent l’Utilisateur dès leur mise en
        ligne. Il convient par conséquent que l’Utilisateur consulte
        régulièrement la présente politique de confidentialité et d’utilisation
        des cookies afin de prendre connaissance de ses éventuelles
        modifications.<br />
      </p>

      <label>II. DONNÉES PERSONNELLES :</label>
      <p>
        Par défaut, Sinepsy ne recueille aucune information personnelle à votre
        sujet. Vous pouvez naviguer sur notre site sans ne nous communiquer
        quelque information que ce soit. Lorsque vous complétez le formulaire de
        contact, nous pouvons recueillir, selon le cas, les informations
        suivantes (ci-après vos « Informations Personnelles ») :<br />
      </p>
      prénom et nom de famille ;<br />
      adresse postale complète (rue, complément d’adresse, code postal,
      ville)<br />
      adresse de courrier électronique ;<br />
      numéro de téléphone ;<br />
      Conformément au Règlement Général sur la Protection des Données (General
      Data Protection Régulation) adopté par le Parlement européen le 14 avril
      2016, et à la Loi Informatique et Libertés du 6 janvier 1978 modifiée,
      Sinepsy vous informe des points suivants :<br />

      <label>1. Identité du responsable du traitement :</label>

      Le responsable du traitement est Sinepsy<br /><br />

      <label>2. Finalités du traitement :</label>
      <p>
        Sinepsy est susceptible de traiter vos Informations Personnelles : (a)
        aux fins de vous fournir les informations ou les services que vous avez
        demandé (notamment : l’envoi de la newsletter, offre commerciale,
        notifications de confirmations d'inscription, sollicitation pour déposer
        vos avis…) ; et/ou (b) aux fins de recueillir des informations nous
        permettant d’améliorer notre Site, nos produits et services (notamment
        par le biais de cookies) ; et/ou (c) aux fins de pouvoir vous contacter
        à propos de différents évènements relatifs à lSinepsy, incluant
        notamment la mise à jour des produits et services.<br />
      </p>

      <label>3. Destinataires :</label>
      <p>
        Seul Sinepsy est destinataire de vos Informations Personnelles.
        Celles-ci, que ce soit sous forme individuelle ou agrégée, ne sont
        jamais transmises à un tiers, nonobstant les sous-traitants auxquels
        Sinepsy fait appel (vous trouverez de plus amples informations à leur
        sujet au point 7 ci-dessous). Ni Sinepsy, ni l’un quelconque de ses
        sous-traitants, ne procèdent à la commercialisation des données
        personnelles des visiteurs et utilisateurs de son Site.<br />
      </p>

      <label>4. Durée de conservation :</label>
      <p>
        Vos Informations Personnelles sont conservées par Sinepsy uniquement
        pour le temps correspondant à la finalité de la collecte tel qu’indiqué
        en 2 ci-dessus qui ne saurait en tout état de cause excéder 36 mois.<br />
      </p>

      <label>5. Droits Informatique et Libertés :</label>
      <p>
        Vous disposez des droits suivants concernant vos Informations
        Personnelles, que vous pouvez exercer en nous écrivant à l’adresse
        postale mentionnée au point 1 ou en remplissant le formulaire
        ci-contre.<br />
      </p>

      <label>Droit d’accès et de communication des données :</label>
      <p>
        Vous avez la faculté d’accéder aux Informations Personnelles qui vous
        concernent. Cependant, en raison de l’obligation de sécurité et de
        confidentialité dans le traitement des données à caractère personnel qui
        incombe à Sinepsy, vous êtes informé que votre demande sera traitée sous
        réserve que vous rapportiez la preuve de votre identité, notamment par
        la production d’un scan de votre titre d’identité valide (en cas de
        demande par notre formulaire de contact électronique) ou d’une
        photocopie signée de votre titre d’identité valide (en cas de demande
        adressée par écrit).<br />

        Sinepsy vous informe qu’elle sera en droit, le cas échéant, de s’opposer
        aux demandes manifestement abusives (de par leur nombre, leur caractère
        répétitif ou systématique).<br />

        Pour vous aider dans votre démarche, notamment si vous désirez exercer
        votre droit d’accès par le biais d’une demande écrite à l’adresse
        postale mentionnée au point 1, vous trouverez en cliquant sur le lien
        suivant un modèle de courrier élaboré par la Commission Nationale de
        l’Informatique et des Libertés (la « CNIL »).
        https://www.cnil.fr/fr/modele/courrier/exercer-son-droit-dacces<br />
      </p>

      <label>Droit de rectification des données :</label>
      <p>
        Au titre de ce droit, la législation vous habilite à demander la
        rectification, la mise à jour, le verrouillage ou encore l’effacement
        des données vous concernant qui peuvent s’avérer le cas échéant
        inexactes, erronées, incomplètes ou obsolètes.<br />

        Également, vous pouvez définir des directives générales et particulières
        relatives au sort des données à caractère personnel après votre décès.
        Le cas échéant, les héritiers d’une personne décédée peuvent exiger de
        prendre en considération le décès de leur proche et/ou de procéder aux
        mises à jour nécessaires.<br />
      </p>

      <label>Droit d’opposition :</label>
      <p>
        L’exercice de ce droit n’est possible que dans l’une des deux situations
        suivantes :<br />

        1. Lorsque l’exercice de ce droit est fondé sur des motifs légitimes
        ;<br />

        ou 2. Lorsque l’exercice de ce droit vise à faire obstacle à ce que les
        données recueillies soient utilisées à des fins de prospection
        commerciale.<br />
      </p>

      <label>6. Délais de réponse :</label>
      <p>
        Sinepsy s’engage à répondre à votre demande d’accès, de rectification ou
        d’opposition ou toute autre demande complémentaire d’informations dans
        un délai raisonnable qui ne saurait dépasser 1 mois à compter de la
        réception de votre demande.<br />
      </p>

      <label>7. Sous-traitants habilités :</label>
      <p>
        Pour assurer nos services, nous sommes amenés à partager nos
        informations avec des applications tierces. De manière générale, les
        fournisseurs tiers que nous utilisons vont uniquement recueillir,
        utiliser et divulguer vos renseignements dans la mesure du nécessaire
        pour pouvoir réaliser les services qu’ils nous fournissent. Nous ne
        traitons qu’avec des sous-traitants respectant la loi de protection des
        données européennes. Ni Sinepsy ni aucun de ses sous-traitants ne
        procède à la commercialisation des données personnelles des utilisateurs
        su Site. Les sous-traitants sont : L’hébergeur du site Internet OVH SAS
        - 2 rue Kellermann - 59100 ROUBAIX - France qui met en œuvre toutes les
        politiques de sécurité et sauvegarde concernant les données stockées sur
        des bases de données<br />

        Sinepsy s’est préalablement assuré de la mise en œuvre par ses
        prestataires de garanties adéquates et du respect de conditions strictes
        en matière de confidentialité, d’usage et de protection des données.
      </p>

      <label>8. Plainte auprès de l’autorité compétente :</label>
      <p>
        Si vous considérez que Sinepsy ne respecte pas ses obligations au regard
        de vos Informations Personnelles, vous pouvez adresser une plainte ou
        une demande auprès de l’autorité compétente. En France, l’autorité
        compétente est la CNIL à laquelle vous pouvez adresser une demande par
        voie électronique en cliquant sur le lien suivant :
        https://www.cnil.fr/fr/plaintes/internet.<br />
      </p>

      <h2>MENTIONS SUR LES COOKIES</h2>

      <p>
        Un cookie est une information déposée sur votre terminal par le serveur
        du site internet que vous visitez, le plus souvent sous forme d'un
        simple fichier texte. Il ne s'agit en aucun cas d'un fichier espion ou
        malveillant. Le cookie a pour but de collecter des informations
        relatives à votre navigation et/ou d’adresser des contenus et services
        adaptés à vos centres d’intérêts. Il contient plusieurs données : le nom
        du serveur l'ayant déposé ; un identifiant unique ; une éventuelle date
        d'expiration.<br />
      </p>

      <label>Cookies présents</label>
      <p>
        Deux types de cookies sont présents sur notre site internet.<br />

        Cookies de mesure d’audience : ils sont utilisés pour établir des
        statistiques de visite sur notre site internet via notre hébergeur
        susnommé et notre plateforme de statistiques.<br />

        Cookies d’identification : ils sont utilisés pour l’ajout d’article au
        panier, le passage de commandes de produits et la connexion à votre
        espace privé, et sont indispensables au bon fonctionnement de notre
        site.<br />
      </p>

      <label>Gestion des cookies</label>
      <p>
        Vous pouvez modifier vos choix concernant le dépôt de cookies par notre
        site internet, en intervenant sur le paramétrage de votre navigateur
        internet. Consentement préalable au dépôt de cookies :<br />

        Il est considéré que vous avez donné votre accord au dépôt de cookies
        par notre site internet si vous avez cliqué sur le bouton OK du bandeau
        d'information stipulant la nécessité d’utilisation des cookies (ce
        bandeau apparaissant uniquement si votre navigateur n’est pas paramétré
        pour autoriser l’utilisation de cookies).<br />
      </p>

      <label>Refus des cookies</label>
      <p>
        Le refus de dépôt des cookies sur votre terminal entraînera
        l’impossibilité de bénéficier du fonctionnement correct de nos services.
        Paramétrage de votre navigateur pour la gestion des cookies :<br />

        En fonction du navigateur internet que vous utilisez, les paramétrages
        sont différents. Vous trouverez ci-dessous des tutoriels détaillés pour
        les navigateurs les plus fréquemment utilisés :<br />

        - Internet Explorer™ :
        http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies<br />

        - Safari™ :
        https://support.apple.com/kb/PH17191?locale=fr_FR&viewlocale=fr_FR<br />

        - Chrome™ :
        http://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647<br />

        - Firefox™ :
        https://support.mozilla.org/fr/kb/activer-desactiver-cookies<br />

        - Opera™ : http://help.opera.com/Windows/10.20/fr/cookies.html<br /><br />

        Nous ne pouvons vous garantir que les liens ci-dessus restent toujours
        valables, les éditeurs étant parfois amenés à héberger leurs aides sur
        d'autres pages que celles-ci sans préavis.<br />

        ----------------
      </p>
    </div>
    <div class="col-2"></div>
  </div>
</div>
